export const adminsConstants = {
    GET_ADMIN_USER_LIST_REQUEST: "GET_ADMIN_USER_LIST_REQUEST",
    GET_ADMIN_USER_LIST_SUCCESS: "GET_ADMIN_USER_LIST_SUCCESS",
    GET_ADMIN_USER_LIST_FAILURE: "GET_ADMIN_USER_LIST_FAILURE"
};

